//
//
//
//
//
//
//
//
//
//

import TransitionFade from './transitions/Fade.vue'
import AppLoader from './components/Loader.vue'
import AppProducts from './components/Products.vue'
import AppDetails from './components/Details.vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'App',
  components: {
    AppLoader,
    AppProducts,
    AppDetails,
    TransitionFade,
  },
  data() {
    return {
      loader: null,
    }
  },
  computed: {
    ...mapGetters(['status', 'specs', 'specLabels']),
  },
  methods: {
    ...mapMutations(['removeComparison']),
    ...mapActions(['fetchData', 'initialize']),
  },
  created() {
    let endpoint = this.$root.src + '?filter=' + this.$root.filter
    this.loader = this.fetchData(endpoint)
  },
  async mounted() {
    await this.loader
    if (this.status.error) return
    let initial = window.matchMedia('(min-width: 768px)').matches ? 3 : 2
    let grid = this.$refs.grid
    this.initialize({ initial, grid })
  },
}
